module.exports = __webpack_public_path__ + "img/bot-right-bg.7ca97f88.png";